import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { LoginContext } from "../context/loginContext";
let redirect;

export const Handle401Error = () => {
    const navigate = useNavigate();
    let {
        dispatch
    } = useContext(LoginContext)

    useEffect(() => {
        redirect = async (path) => {
            navigate(path);
            localStorage.removeItem('accessToken');
            await dispatch({ type: 'LOGIN', data: null });
            await dispatch({ type: 'MEMBER_DETAILS', data: null });
            await dispatch({ type: 'ACCESS_TOKEN', data: null });
        };
    }, []);
};

export const redirectTo = () => {
    redirect('/');
};